var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFylla1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4844,
    height: 151,
    viewBox: "0 0 4844 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.869 9.93619V0.0983768H333.096V0H320.221L356.658 151H369.533L364.559 126.503H389.431V116.666H362.351L336.513 9.93619H365.869Z",
    fill: "#F42272"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M423.74 0L435.832 104.509L387.572 0H371.771L435.832 130.774V151H448.356V122.885L439.658 0H423.74Z",
    fill: "#F42272"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M494.809 141.162L458.372 0H445.497L481.934 151H527.583V141.162H494.809Z",
    fill: "#F42272"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M546.36 141.162L509.922 0H497.047L533.485 151H579.133V141.162H546.36Z",
    fill: "#F42272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M641.218 151H655.264L590.149 0H577.274L585.036 151H599.082L601.081 131.422H631.972L641.218 151ZM601.081 121.585L594.124 48.4522L627.407 121.585H601.081Z",
    fill: "#F42272"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M678.867 9.93619V0.0983768H646.094V0H633.219L669.656 151H682.531L677.557 126.503H702.429V116.666H675.349L649.511 9.93619H678.867Z",
    fill: "#F42272"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M736.738 0L748.83 104.509L700.571 0H684.769L748.83 130.774V151H761.354V122.885L752.656 0H736.738Z",
    fill: "#F42272"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M807.808 141.162L771.37 0H758.495L794.932 151H840.581V141.162H807.808Z",
    fill: "#F42272"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M859.358 141.162L822.92 0H810.045L846.483 151H892.131V141.162H859.358Z",
    fill: "#F42272"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M954.216 151H968.262L903.147 0H890.272L898.034 151H912.08L914.079 131.422H944.97L954.216 151ZM914.079 121.585L907.122 48.4522L940.405 121.585H914.079Z",
    fill: "#F42272"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45.648 9.93619V0.0983768H12.8751V0H0L36.4371 151H49.3122L44.3387 126.503H69.2102V116.666H42.1303L16.2918 9.93619H45.648Z",
    fill: "#F42272"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.519 0L115.611 104.509L67.3518 0H51.5506L115.611 130.774V151H128.135V122.885L119.437 0H103.519Z",
    fill: "#F42272"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.589 141.162L138.151 0H125.276L161.714 151H207.362V141.162H174.589Z",
    fill: "#F42272"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M226.139 141.162L189.702 0H176.826L213.264 151H258.912V141.162H226.139Z",
    fill: "#F42272"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M320.998 151H335.043L269.928 0H257.053L264.815 151H278.861L280.86 131.422H311.751L320.998 151ZM280.86 121.585L273.904 48.4522L307.186 121.585H280.86Z",
    fill: "#F42272"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1334.87 9.93619V0.0983768H1302.1V0H1289.22L1325.66 151H1338.53L1333.56 126.503H1358.43V116.666H1331.35L1305.51 9.93619H1334.87Z",
    fill: "#F42272"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1392.74 0L1404.83 104.509L1356.57 0H1340.77L1404.83 130.774V151H1417.36V122.885L1408.66 0H1392.74Z",
    fill: "#F42272"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1463.81 141.162L1427.37 0H1414.5L1450.93 151H1496.58V141.162H1463.81Z",
    fill: "#F42272"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1515.36 141.162L1478.92 0H1466.05L1502.48 151H1548.13V141.162H1515.36Z",
    fill: "#F42272"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1610.22 151H1624.26L1559.15 0H1546.27L1554.04 151H1568.08L1570.08 131.422H1600.97L1610.22 151ZM1570.08 121.585L1563.12 48.4522L1596.41 121.585H1570.08Z",
    fill: "#F42272"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.87 9.93619V0.0983768H1615.09V0H1602.22L1638.66 151H1651.53L1646.56 126.503H1671.43V116.666H1644.35L1618.51 9.93619H1647.87Z",
    fill: "#F42272"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1705.74 0L1717.83 104.509L1669.57 0H1653.77L1717.83 130.774V151H1730.35V122.885L1721.66 0H1705.74Z",
    fill: "#F42272"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1776.81 141.162L1740.37 0H1727.49L1763.93 151H1809.58V141.162H1776.81Z",
    fill: "#F42272"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1828.36 141.162L1791.92 0H1779.04L1815.48 151H1861.13V141.162H1828.36Z",
    fill: "#F42272"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1923.22 151H1937.26L1872.15 0H1859.27L1867.03 151H1881.08L1883.08 131.422H1913.97L1923.22 151ZM1883.08 121.585L1876.12 48.4522L1909.41 121.585H1883.08Z",
    fill: "#F42272"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.65 9.93619V0.0983768H981.875V0H969L1005.44 151H1018.31L1013.34 126.503H1038.21V116.666H1011.13L985.292 9.93619H1014.65Z",
    fill: "#F42272"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1072.52 0L1084.61 104.509L1036.35 0H1020.55L1084.61 130.774V151H1097.14V122.885L1088.44 0H1072.52Z",
    fill: "#F42272"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.59 141.162L1107.15 0H1094.28L1130.71 151H1176.36V141.162H1143.59Z",
    fill: "#F42272"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1195.14 141.162L1158.7 0H1145.83L1182.26 151H1227.91V141.162H1195.14Z",
    fill: "#F42272"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1290 151H1304.04L1238.93 0H1226.05L1233.81 151H1247.86L1249.86 131.422H1280.75L1290 151ZM1249.86 121.585L1242.9 48.4522L1276.19 121.585H1249.86Z",
    fill: "#F42272"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2304.87 9.93619V0.0983768H2272.1V0H2259.22L2295.66 151H2308.53L2303.56 126.503H2328.43V116.666H2301.35L2275.51 9.93619H2304.87Z",
    fill: "#F42272"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2362.74 0L2374.83 104.509L2326.57 0H2310.77L2374.83 130.774V151H2387.36V122.885L2378.66 0H2362.74Z",
    fill: "#F42272"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2433.81 141.162L2397.37 0H2384.5L2420.93 151H2466.58V141.162H2433.81Z",
    fill: "#F42272"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M2485.36 141.162L2448.92 0H2436.05L2472.48 151H2518.13V141.162H2485.36Z",
    fill: "#F42272"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2580.22 151H2594.26L2529.15 0H2516.27L2524.04 151H2538.08L2540.08 131.422H2570.97L2580.22 151ZM2540.08 121.585L2533.12 48.4522L2566.41 121.585H2540.08Z",
    fill: "#F42272"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M2617.87 9.93619V0.0983768H2585.09V0H2572.22L2608.66 151H2621.53L2616.56 126.503H2641.43V116.666H2614.35L2588.51 9.93619H2617.87Z",
    fill: "#F42272"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2675.74 0L2687.83 104.509L2639.57 0H2623.77L2687.83 130.774V151H2700.35V122.885L2691.66 0H2675.74Z",
    fill: "#F42272"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M2746.81 141.162L2710.37 0H2697.5L2733.93 151H2779.58V141.162H2746.81Z",
    fill: "#F42272"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2798.36 141.162L2761.92 0H2749.04L2785.48 151H2831.13V141.162H2798.36Z",
    fill: "#F42272"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2893.22 151H2907.26L2842.15 0H2829.27L2837.03 151H2851.08L2853.08 131.422H2883.97L2893.22 151ZM2853.08 121.585L2846.12 48.4522L2879.41 121.585H2853.08Z",
    fill: "#F42272"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1984.65 9.93619V0.0983768H1951.88V0H1939L1975.44 151H1988.31L1983.34 126.503H2008.21V116.666H1981.13L1955.29 9.93619H1984.65Z",
    fill: "#F42272"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M2042.52 0L2054.61 104.509L2006.35 0H1990.55L2054.61 130.774V151H2067.14V122.885L2058.44 0H2042.52Z",
    fill: "#F42272"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2113.59 141.162L2077.15 0H2064.28L2100.71 151H2146.36V141.162H2113.59Z",
    fill: "#F42272"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2165.14 141.162L2128.7 0H2115.83L2152.26 151H2197.91V141.162H2165.14Z",
    fill: "#F42272"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M2260 151H2274.04L2208.93 0H2196.05L2203.81 151H2217.86L2219.86 131.422H2250.75L2260 151ZM2219.86 121.585L2212.9 48.4522L2246.19 121.585H2219.86Z",
    fill: "#F42272"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3272.87 9.93619V0.0983768H3240.1V0H3227.22L3263.66 151H3276.53L3271.56 126.503H3296.43V116.666H3269.35L3243.51 9.93619H3272.87Z",
    fill: "#F42272"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M3330.74 0L3342.83 104.509L3294.57 0H3278.77L3342.83 130.774V151H3355.36V122.885L3346.66 0H3330.74Z",
    fill: "#F42272"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3401.81 141.162L3365.37 0H3352.5L3388.93 151H3434.58V141.162H3401.81Z",
    fill: "#F42272"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M3453.36 141.162L3416.92 0H3404.05L3440.48 151H3486.13V141.162H3453.36Z",
    fill: "#F42272"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M3548.22 151H3562.26L3497.15 0H3484.27L3492.04 151H3506.08L3508.08 131.422H3538.97L3548.22 151ZM3508.08 121.585L3501.12 48.4522L3534.41 121.585H3508.08Z",
    fill: "#F42272"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M3585.87 9.93619V0.0983768H3553.09V0H3540.22L3576.66 151H3589.53L3584.56 126.503H3609.43V116.666H3582.35L3556.51 9.93619H3585.87Z",
    fill: "#F42272"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M3643.74 0L3655.83 104.509L3607.57 0H3591.77L3655.83 130.774V151H3668.35V122.885L3659.66 0H3643.74Z",
    fill: "#F42272"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M3714.81 141.162L3678.37 0H3665.5L3701.93 151H3747.58V141.162H3714.81Z",
    fill: "#F42272"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M3766.36 141.162L3729.92 0H3717.04L3753.48 151H3799.13V141.162H3766.36Z",
    fill: "#F42272"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M3861.22 151H3875.26L3810.15 0H3797.27L3805.03 151H3819.08L3821.08 131.422H3851.97L3861.22 151ZM3821.08 121.585L3814.12 48.4522L3847.41 121.585H3821.08Z",
    fill: "#F42272"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2952.65 9.93619V0.0983768H2919.88V0H2907L2943.44 151H2956.31L2951.34 126.503H2976.21V116.666H2949.13L2923.29 9.93619H2952.65Z",
    fill: "#F42272"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M3010.52 0L3022.61 104.509L2974.35 0H2958.55L3022.61 130.774V151H3035.14V122.885L3026.44 0H3010.52Z",
    fill: "#F42272"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3081.59 141.162L3045.15 0H3032.28L3068.71 151H3114.36V141.162H3081.59Z",
    fill: "#F42272"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M3133.14 141.162L3096.7 0H3083.83L3120.26 151H3165.91V141.162H3133.14Z",
    fill: "#F42272"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M3228 151H3242.04L3176.93 0H3164.05L3171.81 151H3185.86L3187.86 131.422H3218.75L3228 151ZM3187.86 121.585L3180.9 48.4522L3214.19 121.585H3187.86Z",
    fill: "#F42272"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M4240.87 9.93619V0.0983768H4208.1V0H4195.22L4231.66 151H4244.53L4239.56 126.503H4264.43V116.666H4237.35L4211.51 9.93619H4240.87Z",
    fill: "#F42272"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M4298.74 0L4310.83 104.509L4262.57 0H4246.77L4310.83 130.774V151H4323.36V122.885L4314.66 0H4298.74Z",
    fill: "#F42272"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M4369.81 141.162L4333.37 0H4320.5L4356.93 151H4402.58V141.162H4369.81Z",
    fill: "#F42272"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4421.36 141.162L4384.92 0H4372.05L4408.48 151H4454.13V141.162H4421.36Z",
    fill: "#F42272"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4516.22 151H4530.26L4465.15 0H4452.27L4460.04 151H4474.08L4476.08 131.422H4506.97L4516.22 151ZM4476.08 121.585L4469.12 48.4522L4502.41 121.585H4476.08Z",
    fill: "#F42272"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M4553.87 9.93619V0.0983768H4521.09V0H4508.22L4544.66 151H4557.53L4552.56 126.503H4577.43V116.666H4550.35L4524.51 9.93619H4553.87Z",
    fill: "#F42272"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4611.74 0L4623.83 104.509L4575.57 0H4559.77L4623.83 130.774V151H4636.35V122.885L4627.66 0H4611.74Z",
    fill: "#F42272"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M4682.81 141.162L4646.37 0H4633.5L4669.93 151H4715.58V141.162H4682.81Z",
    fill: "#F42272"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M4734.36 141.162L4697.92 0H4685.04L4721.48 151H4767.13V141.162H4734.36Z",
    fill: "#F42272"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M4829.22 151H4843.26L4778.15 0H4765.27L4773.03 151H4787.08L4789.08 131.422H4819.97L4829.22 151ZM4789.08 121.585L4782.12 48.4522L4815.41 121.585H4789.08Z",
    fill: "#F42272"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M3920.65 9.93619V0.0983768H3887.88V0H3875L3911.44 151H3924.31L3919.34 126.503H3944.21V116.666H3917.13L3891.29 9.93619H3920.65Z",
    fill: "#F42272"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M3978.52 0L3990.61 104.509L3942.35 0H3926.55L3990.61 130.774V151H4003.14V122.885L3994.44 0H3978.52Z",
    fill: "#F42272"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4049.59 141.162L4013.15 0H4000.28L4036.71 151H4082.36V141.162H4049.59Z",
    fill: "#F42272"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M4101.14 141.162L4064.7 0H4051.83L4088.26 151H4133.91V141.162H4101.14Z",
    fill: "#F42272"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M4196 151H4210.04L4144.93 0H4132.05L4139.81 151H4153.86L4155.86 131.422H4186.75L4196 151ZM4155.86 121.585L4148.9 48.4522L4182.19 121.585H4155.86Z",
    fill: "#F42272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFylla1);
export default __webpack_public_path__ + "static/media/fylla1.1d5c856f5431db6a4c9602dbd55f41b3.svg";
export { ForwardRef as ReactComponent };